// extracted by mini-css-extract-plugin
export default {"spacer":"XcpcFGoHjezacMoxFgT0","wheel_picker_box":"gZemRi98uY906v8uN8sy"};